import React from 'react';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { PrivacyTermsPage } from '@codes/shared';

import { PrivacyPage, TermsOfServicePage } from '../pages';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const PolicyRoutes = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/privacy-terms" element={<PrivacyTermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                <Route path="*" element={<Navigate to="/policy/privacy-terms"></Navigate>}></Route>
            </Routes>
        </>
    );
};
